import AddressList from './addressList';

export default AddressList;
